import React from 'react';
import NutritionInput from '../Modules/Create/NutritionInput'

function Create() {
  return (
    <div className='createPage'>
      <NutritionInput />
    </div>
  );
}

export default Create;